module.exports = __webpack_public_path__ + "static/media/trad.ac9ff117.png";